import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LeaderboardService, FileService } from '../../../core';
import { managerApi } from '../../../config';

@Component({
  selector: 'app-seller-sales-tab',
  templateUrl: './seller-sales-tab.component.html',
  styleUrls: ['./seller-sales-tab.component.scss']
})
export class SellerSalesTabComponent implements OnInit {
  @Input() bonusIncentives: any;
  @Input() userProfile: any;
  @Output() activityChallengeClick = new EventEmitter<any>();

  quarterList: any[] = [];
  selectedQuarter: any = null;
  quarterDropdownItems: any[] = [];
  viewQuarterDropdownItems: any[] = [];
  previewModalOpen: boolean = false;
  previewUrl: string = '';
  previewSafeUrl: any = null;
  previewQuarterLabel: string = '';
  previewLoading: boolean = false;
  previewApiUrl: string = '';
  downloadLoading: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private leaderboardService: LeaderboardService,
    private fileService: FileService
  ) {}

  ngOnInit() {
    this.loadQuarterList();
  }

  loadQuarterList() {
    const req = 'includeCurrentQuarter=true&noOfPreviousQuarters=1';
    this.leaderboardService.getquaterListForDistributorChgFlag(req).subscribe((data: any) => {
      this.quarterList = data || [];
      if (this.quarterList.length > 0) {
        this.selectedQuarter = this.quarterList[0];
      }
      this.quarterDropdownItems = this.quarterList.map((q, i) => ({
        label: this.getQuarterLabel(q),
        value: q,
        checked: i === 0
      }));
      this.viewQuarterDropdownItems = this.quarterList.map((q, i) => ({
        label: this.getQuarterLabel(q),
        value: q,
        checked: i === 0
      }));
    });
  }

  getQuarterLabel(q: any): string {
    if (q.currentQuarter) { return 'Current Quarter (' + q.fiscalQuarter + ')'; }
    if (q.previousQuarter) { return 'Previous Quarter (' + q.fiscalQuarter + ')'; }
    return q.fiscalQuarter;
  }

  onQuarterDropdownChange(item: any) {
    const quarter = item.value;
    this.selectedQuarter = quarter;
    this.quarterDropdownItems = this.quarterList.map(q => ({
      label: this.getQuarterLabel(q),
      value: q,
      checked: q === this.selectedQuarter
    }));
    const apiUrl = managerApi.eligibleProductsDownload + '?fiscalYear=' + quarter.fiscalYear + '&quarter=' + quarter.fiscalQuarter;
    this.downloadLoading = true;
    this.fileService.downloadFile(apiUrl).subscribe(
      () => { this.downloadLoading = false; },
      () => { this.downloadLoading = false; }
    );
  }

  onViewQuarterChange(item: any) {
    const quarter = item.value;
    this.previewQuarterLabel = this.getQuarterLabel(quarter);
    this.previewLoading = true;
    this.previewUrl = '';
    this.previewSafeUrl = null;
    this.previewApiUrl = managerApi.eligibleProductsPreview + '?fiscalYear=' + quarter.fiscalYear + '&quarter=' + quarter.fiscalQuarter;
    this.previewModalOpen = true;
    this.viewQuarterDropdownItems = this.quarterList.map(q => ({
      label: this.getQuarterLabel(q),
      value: q,
      checked: q === quarter
    }));
    this.fileService.getBlobUrl(this.previewApiUrl).subscribe(
      (blobUrl: string) => {
        this.previewUrl = blobUrl;
        this.previewSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        this.previewLoading = false;
      },
      () => { this.previewLoading = false; }
    );
  }

  downloadPreviewFile() {
    if (this.previewApiUrl) {
      this.downloadLoading = true;
      this.fileService.downloadFile(this.previewApiUrl).subscribe(
        () => { this.downloadLoading = false; },
        () => { this.downloadLoading = false; }
      );
    }
  }

  closePreviewModal() {
    this.previewModalOpen = false;
    this.previewUrl = '';
    this.previewSafeUrl = null;
  }
}
